<script setup lang="ts">
import CoreIcon from '@core/core-icon.vue';
import {hapticFeedback} from "@tma.js/sdk-vue";
import isInTelegram from "@/utils/isInTelegram";

const props = defineProps({
	list: {
		type: Array,
		default: () => []
	}
});

const hapticHandler = async () => {
  if (isInTelegram() && hapticFeedback.impactOccurred.isAvailable()) {
    hapticFeedback.impactOccurred('medium');
  }
}
</script>

<template>
	<div class="part-navigation-bar">
		<ul
			v-if="list"
			class="part-navigation-bar__list"
		>
			<li
				v-for="(item, index) in list" :key="index"
				class="part-navigation-bar__list-item"
			>
				<router-link :to="item.url"
                     class="part-navigation-bar__list-link"
                     @click.native="hapticHandler"
        >
					<span class="part-navigation-bar__list-icon">
						<core-icon
							v-if="item.icon"
							v-bind="item.icon"
						>
						</core-icon>
					</span>
				</router-link>
			</li>
		</ul>
	</div>
</template>

<style lang="scss">
.part-navigation-bar {
	background-color: #fff;
	border-radius: 1.6rem 1.6rem 0 0;

	@include theme-dark {
		background: rgba(0, 28, 51, 0.12);
		backdrop-filter: blur(22px);
		border-top: 1px solid var(--color-panel);
	}

	&__list {
		height: var(--navigation-bar-height);
		display: flex;
		align-items: center;
		justify-content: space-evenly;
		gap: 1rem;
		max-width: var(--max-page-width);
		margin: auto;
	}

	&__list-item {
		flex: 0 1 auto;
		min-width: 0;
		display: block;
	}

	&__list-link {
		max-width: 100%;
		height: 4.8rem;
		width: 7.2rem;
		display: flex;
		justify-content: center;
		align-items: center;
		fill: var(--color-text);
		transition: ease 0.2s;
		border-radius: 1.6rem;

		&.router-link-active {
			fill: var(--color-active);
			background: rgba(115, 93, 207, 0.06);

			@include theme-dark {
				backdrop-filter: blur(3px);
				background-color: var(--color-panel);
				box-shadow: inset 1px 1px 1px 0px var(--color-panel);
			}
		}

		&:active {
			.part-navigation-bar__list-icon {
				transform: scale(0.9);
			}
		}
	}

	&__list-icon{
		svg {
			width: 1.8rem;
		}

	}
}
</style>

